import { Component, OnInit } from '@angular/core';
import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-relation-ships',
  templateUrl: './relation-ships.component.html',
  styleUrls: ['./relation-ships.component.scss']
})
export class RelationShipsComponent implements OnInit {

  public companies = [
    {logo:'/assets/images/ticor_logo.png'},
    {logo:'/assets/images/remax_logo.png'},
    {logo:'/assets/images/wells_logo.png'},
    {logo:'/assets/images/fidelity_logo.png'},
    {logo:'/assets/images/kinecta_logo.png'},
    {logo:'/assets/images/layers_logo.png'}
  ];

  ngAfterViewInit(){
    $('.relation').slick({
      autoplay: false,
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            dots: true,
          }
        }
      ]
    });
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/relation-ships/relation-ships.component.ts